// Alış faturasında aynı stoklu ürün birden fazla satırda olabilir. Ürünün alış fiyatı (kart / şube)
// o faturadaki EN PAHALI satırın birim maliyetinden güncellenir; sunucudaki PurchasePriceCalculator
// ile aynı kural: birim maliyet = (iskonto düşülmüş KDV hariç tutar + ÖTV) / miktar. Bedelsiz satır sayılmaz.
import type { InvoiceItem } from '../components/types/invoice.types';

export interface DuplicateLineHint {
  /** Ürünün bu faturadaki satır sayısı. */
  count: number;
  /** Alış fiyatına yazılacak birim maliyet (belge para biriminde). */
  maxCost: number;
  /** Bu satır en pahalı satır mı? */
  isMax: boolean;
}

const unitCost = (line: Pick<InvoiceItem, 'quantity' | 'netTotal' | 'sctAmount'>): number | null => {
  const qty = Number(line.quantity) || 0;
  if (qty <= 0) return null;
  const cost = Math.round(((Number(line.netTotal) || 0) + (Number(line.sctAmount) || 0)) / qty * 100) / 100;
  return cost > 0 ? cost : null;
};

/**
 * Aynı ürünün farklı birim maliyetle birden fazla satırda geçtiği satırlar için not bilgisi
 * (satır id → bilgi). Tek satırlı ya da tüm satırları aynı fiyatlı ürünler için not yoktur.
 */
export function purchaseDuplicateHints(items: InvoiceItem[]): Map<string, DuplicateLineHint> {
  const groups = new Map<string, InvoiceItem[]>();
  for (const line of items) {
    if (!line.itemId || line.itemId.startsWith('manual_')) continue;
    const list = groups.get(line.itemId) ?? [];
    list.push(line);
    groups.set(line.itemId, list);
  }

  const hints = new Map<string, DuplicateLineHint>();
  groups.forEach((lines) => {
    if (lines.length < 2) return;
    const costs = lines.map(unitCost);
    const valid = costs.filter((c): c is number => c !== null);
    if (valid.length === 0) return;
    const maxCost = Math.max(...valid);
    if (valid.every(c => c === maxCost) && valid.length === lines.length) return;
    lines.forEach((line, i) => hints.set(line.id, { count: lines.length, maxCost, isMax: costs[i] === maxCost }));
  });
  return hints;
}
